import Button from "components/Form/fields/Button";
import React from "react";
import { BUTTON_CLASS_CONTEXT } from "utils/constants/ui";

const LoadMoreFooter = ({
  setLoadCount,
  loadCount,
  rowsCount,
  initialCount,
  search,
  virtualized
}) => {
  const disableMore = loadCount >= rowsCount;
  const searchNote = search
    ? `${rowsCount} matches`
    : virtualized
    ? `${rowsCount} rows`
    : `${disableMore ? rowsCount : loadCount} of ${rowsCount}`;

  return (
    <div className="pa3 w-100 flex flex-row justify-between items-center">
      <div className="f6">{searchNote}</div>
      {!virtualized && (
        <Button
          theme="slim"
          copy="Load all"
          disabled={disableMore}
          classes={{
            contextClass: BUTTON_CLASS_CONTEXT.SECONDARY
          }}
          onClick={() => {
            setLoadCount(initialCount);
          }}
        />
      )}
    </div>
  );
};

export default LoadMoreFooter;
